import type { AdminOrg } from '../api/types';

/**
 * The org list after a write settled one of its rows.
 *
 * `GET /admin/orgs` is read once, on mount, and the spend limit is written from
 * a panel below the table it was read into. Without this the list keeps the row
 * as it stood before the save, and re-opening the org re-seeds the field from
 * that stale row — the saved cap disappears from the control that just wrote it.
 * The write answers with the row the server settled on, so the fix is to put
 * that row back where the stale one was rather than to read the list again.
 *
 * The **same array** comes back when nothing moved — an id the list does not
 * carry, or the row already being the one held. A caller passing this to
 * `setState` therefore does not re-render on a row it already had.
 */
export function replaceOrg(orgs: AdminOrg[] | null, org: AdminOrg): AdminOrg[] | null {
  if (orgs === null) return null;
  let moved = false;
  const next = orgs.map((row) => {
    if (row.id !== org.id || row === org) return row;
    moved = true;
    return org;
  });
  return moved ? next : orgs;
}
